export const content = document.querySelector("main .content");
export const templates = {
  vehiclesPage: document.querySelector<HTMLTemplateElement>("template[name='vehicles-page']"),
  traction: document.querySelector<HTMLTemplateElement>("template[name='traction']"),
  model: document.querySelector<HTMLTemplateElement>("template[name='model']"),
  vehicleTag: document.querySelector<HTMLTemplateElement>("template[name='vehicle-tag']")
};
export const dialogs = {
  vehicleView: {
    self: document.querySelector<HTMLDialogElement>("dialog[name='vehicle-view']"),
    close: document.querySelector<HTMLDivElement>("dialog[name='vehicle-view'] .close"),
    tag: document.querySelector<HTMLSpanElement>("dialog[name='vehicle-view'] .tag"),
    heading: document.querySelector<HTMLHeadingElement>("dialog[name='vehicle-view'] h2"),
    seznamAutobusu: document.querySelector<HTMLAnchorElement>("dialog[name='vehicle-view'] a.seznam-autobusu"),
    provoz: document.querySelector<HTMLAnchorElement>("dialog[name='vehicle-view'] a.provoz"),
    delay: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .delay label"),
    paintContainer: document.querySelector<HTMLDivElement>("dialog[name='vehicle-view'] .vehicle-metadata.paint"),
    paint: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .paint label"),
    path: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .path label"),
    lastStop: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .last-stop label"),
    nextStop: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .next-stop label"),
    order: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .order label"),
    shift: document.querySelector<HTMLLabelElement>("dialog[name='vehicle-view'] .shift label"),
    connectionTableBody: document.querySelector<HTMLTableSectionElement>("dialog[name='vehicle-view'] .connection tbody"),
    lastPhotoBlock: document.querySelector<HTMLDivElement>("dialog[name='vehicle-view'] .last-photo-block"),
    lastPhoto: document.querySelector<HTMLDivElement>("dialog[name='vehicle-view'] .last-photo")
  },
  faqView: {
    self: document.querySelector<HTMLDialogElement>("dialog[name='faq-view']"),
    close: document.querySelector<HTMLDivElement>("dialog[name='faq-view'] .close")
  }
};
export const vehicleCount = document.querySelector<HTMLSpanElement>(".vehicle-count");
export const status = document.querySelector<HTMLParagraphElement>(".status");
export const retryApi = document.querySelector<HTMLButtonElement>(".retry-api");
export const disclaimer = document.querySelector<HTMLParagraphElement>(".disclaimer");
